/**
 * Convert string into enum case.
 * Join punctuation with slash.
 * @memberof module:stringcase/lib
 * @function enumcase
 * @param {string} str - String to convert.
 * @returns {string} Enum cased string.
 */
'use strict';

var snakecase = require('./snakecase');
/** @lends enumcase */


function enumcase(str) {
  return snakecase(str).replace(/_/g, ':');
}

module.exports = enumcase;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImVudW1jYXNlLmpzIl0sIm5hbWVzIjpbInNuYWtlY2FzZSIsInJlcXVpcmUiLCJlbnVtY2FzZSIsInN0ciIsInJlcGxhY2UiLCJtb2R1bGUiLCJleHBvcnRzIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7QUFTQTs7QUFFQSxJQUFNQSxTQUFTLEdBQUdDLE9BQU8sQ0FBQyxhQUFELENBQXpCO0FBRUE7OztBQUNBLFNBQVNDLFFBQVQsQ0FBbUJDLEdBQW5CLEVBQXdCO0FBQ3RCLFNBQU9ILFNBQVMsQ0FBQ0csR0FBRCxDQUFULENBQWVDLE9BQWYsQ0FBdUIsSUFBdkIsRUFBNkIsR0FBN0IsQ0FBUDtBQUNEOztBQUVEQyxNQUFNLENBQUNDLE9BQVAsR0FBaUJKLFFBQWpCIiwic291cmNlUm9vdCI6Ii4uLy4uL2xpYiIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29udmVydCBzdHJpbmcgaW50byBlbnVtIGNhc2UuXG4gKiBKb2luIHB1bmN0dWF0aW9uIHdpdGggc2xhc2guXG4gKiBAbWVtYmVyb2YgbW9kdWxlOnN0cmluZ2Nhc2UvbGliXG4gKiBAZnVuY3Rpb24gZW51bWNhc2VcbiAqIEBwYXJhbSB7c3RyaW5nfSBzdHIgLSBTdHJpbmcgdG8gY29udmVydC5cbiAqIEByZXR1cm5zIHtzdHJpbmd9IEVudW0gY2FzZWQgc3RyaW5nLlxuICovXG5cbid1c2Ugc3RyaWN0J1xuXG5jb25zdCBzbmFrZWNhc2UgPSByZXF1aXJlKCcuL3NuYWtlY2FzZScpXG5cbi8qKiBAbGVuZHMgZW51bWNhc2UgKi9cbmZ1bmN0aW9uIGVudW1jYXNlIChzdHIpIHtcbiAgcmV0dXJuIHNuYWtlY2FzZShzdHIpLnJlcGxhY2UoL18vZywgJzonKVxufVxuXG5tb2R1bGUuZXhwb3J0cyA9IGVudW1jYXNlXG4iXX0=